// Package imports:
import React from 'react';
// Component imports:
import Markhopalistar from '../../components/Markhopalistar/Markhopalistar';
import Entrypoint from '../Entrypoint';

const MarkhopalistarPage: React.FC = () => {
    return (
        <Entrypoint>
            <Markhopalistar />
        </Entrypoint>
    );
}

export default MarkhopalistarPage;